import { useFetchCheckout } from './../../utils/functions';
import { DeleteCheckoutButton } from '../buttons/deleteCheckoutButton/DeleteCheckoutButton';
import Preloader from '../preloader/Preloader';
import { CartImg } from './../../utils/svg';

import styles from './Cabinet.module.css';

export const Cabinet = ({
    isAuthorized
}) => {

    const { isLoading, products } = useFetchCheckout();

    const allProducts = [];
    const finalProducts = [];

    const backgroundColorHonest = {
        backgroundColor: "#5490f0"
    }
    const backgroundColorOdd = {
        backgroundColor: "#7FFF00"
    }

    // for (let i = 0; i < products.length; i++) {
    //     for (let key in products[i]) {
    //         allProducts.push(products[i][key]);
    //     }
    // }

    // for (let j = 0; j < allProducts.length; j++) {
    //     if (typeof (allProducts[j]) === 'object') {
    //         finalProducts.push(allProducts[j])
    //     }
    // }



    // function getProp(obj) {
    //     for(var prop in obj) {
    //         if(typeof(obj[prop]) === 'object') {
    //             console.log(obj[prop])
    //             for(var prop2 in obj[prop]) {
    //                 if(typeof(obj[prop][prop2]) === 'object') {
    //                     // for (let i = 0; i < prop2.length; i++) {
    //                     //     allProducts.splice(i, [obj[prop][prop2]])
    //                     // }
    //                     console.log(obj[prop][prop2])
    //                     //... другие вложенные циклы for...in
    //                 }
    //             }
    //         }
    //     }
    // }

    // getProp(products)

    let infoArr = []
    let cardsArr = [];

    for (let i = 0; i < products.length; i++) {
        infoArr.push([Object.values(products[i])])
    }

    let arr = infoArr.flat()

    for (let item of arr) {
        item.shift()
    }


    //MODIFY ARR THAT RETURN FIRST IN ARR.ITEM INFO ABOUT ORDER
    for (let i = 0; i < arr.length; i++) {

        let item = arr[i]
        let search = "orderCreated"

        for (let j = 0; j < item.length; j++) {
            if (Object.keys(item[j]).includes(search)) {
                let w = item.indexOf(item[j])
                let p = item.splice(w, 1)

                for (let k = 0; k < p.length; k++) {
                    item.push(p[k])
                }
            }
        }
    }


    //SORT ARR

    function sortByOrderCreated(a, b) {
        let orderA = a.find(obj =>
            obj.orderCreated !== undefined);
        let orderB = b.find(obj =>
            obj.orderCreated !== undefined);

            if (orderA && orderB) {
                return orderA.orderCreated - orderB.orderCreated;
            }
            return 0;
    }

    return (
        <div className={styles.container}>
            {isAuthorized ?
                <div className={styles.cardsContainerWrapper}>
                    <p className={styles.title}>Мої замовлення:</p>
                    {(isLoading === false) ?
                        <div className={styles.cardsContainer}>
                            {
                                (arr.length > 0) ?
                                    <div className={styles.card}>
                                        {
                                            arr
                                                .sort(sortByOrderCreated)
                                                .map((item, index) => item.map((product) => (
                                                    <div style={(index % 2 == 0) ? backgroundColorHonest : backgroundColorOdd}>

                                                        {
                                                            !product.totalOrderSum ?
                                                                <div className={styles.cardItem}>
                                                                    <div>
                                                                        <img src={product.url} alt="image" className={styles.image} />
                                                                    </div>

                                                                    <h4 className={styles.name}>{product.name}</h4>

                                                                    <div className={styles.count}>
                                                                        {product.count} шт
                                                                    </div>
                                                                    <div className={styles.productPrice}>
                                                                        {product.totalPrice} грн
                                                                    </div>
                                                                </div>
                                                                : null
                                                        }

                                                        {
                                                            (product.totalOrderSum) ?
                                                                <div className={styles.infoItem}>
                                                                    <div className={styles.time}>
                                                                        Створено: {product.time}
                                                                    </div>
                                                                    <div className={styles.address}>
                                                                        Адреса: {product.address}
                                                                    </div>
                                                                    <div className={styles.phone}>
                                                                        Тел: {product.phone}
                                                                    </div>
                                                                    <div className={styles.productOrderPrice}>
                                                                        Загальна сума: {product.totalOrderSum} грн
                                                                    </div>
                                                                    <div className={styles.deleteButton}>
                                                                        <DeleteCheckoutButton phone={product.phone} />
                                                                    </div>

                                                                </div>
                                                                : null
                                                        }

                                                    </div>
                                                )))
                                        }
                                    </div>
                                    :
                                    <div className={styles.cartImgContainer}>
                                        <CartImg />
                                        <div>
                                            <span>Схоже ще ніхто не зголоднів</span>
                                        </div>
                                    </div>
                            }
                        </div>
                        : <Preloader />}
                </div>
                : null}
        </div>
    )
}